import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormMode } from '../utils/extensions/constantEx'
import { NurseFormContextProvider } from '../utils/contexts/nurseFormContext';
import NurseForm from './nurseForm';

export default function NurseFormWrapper(props) {

    const { formMode } = props;
    const location = useLocation();

    const [selectedNurseId, setSelectedNurseId] = useState(0);
    const [formOpenMode, setFormOpenMode] = useState(formMode ?? FormMode.NewMode);


    useEffect(() => {

        if (location && location.state && location.state.selectedId && location.state.selectedId > 0) {
            setFormOpenMode(FormMode.ViewMode);
            setSelectedNurseId(location.state.selectedId);
        } else {
            setFormOpenMode(formMode ?? FormMode.NewMode);
            setSelectedNurseId(0);
        }
    }, [location]);


    return (
        <NurseFormContextProvider>
            <NurseForm formMode={formOpenMode} selectedNurseId={selectedNurseId} />
        </NurseFormContextProvider>
    );

}
